import React from 'react';
import "./card.css";
import { Link } from 'react-router-dom';
import { BiGroup } from 'react-icons/bi';
import { BsTicketDetailed } from 'react-icons/bs';
import { FaChartBar } from 'react-icons/fa';

const Navigate = [
    {
        title: 'Tickets',
        icon: <BsTicketDetailed />,
        link: '/tickets'
    },
    {
        title: 'Agents',
        icon: <BiGroup />
    },
    {
        title: 'Statistics',
        icon: <FaChartBar />,
        link: '/tickettrafficmanagement'
    },
];

const Card = () => {
  return (
    <div className="card--container">
        {Navigate.map((item, index) => (
            <Link key={index} to={item.link || ''}  className={`card card-${index}`}>
              <div className="card--cover">
                {/* Render either an image or the FaChartBar icon */}
                {item.icon && typeof item.icon === 'string' ? (
                  <img src={item.icon} alt={item.title} />
                ) : (
                  item.icon
                )}
              </div>
              <div className="card--title">
                <h2>{item.title}</h2>
              </div>
            </Link>
        ))}
    </div>
  );
}

export default Card;
